import { useLocation } from "react-router-dom";
import { PageFallbackSkeleton } from "./PageFallbackSkeleton";
import { AdminContentSkeleton } from "./AdminContentSkeleton";
import { ChatPageSkeleton } from "./ChatPageSkeleton";

/**
 * Top-level Suspense fallback for lazy-loaded routes.
 * Returns the appropriate skeleton based on the current path.
 */
export function RouteAwareAppFallback() {
  const { pathname } = useLocation();

  if (pathname.startsWith("/chat")) {
    return <ChatPageSkeleton />;
  }

  if (pathname.startsWith("/admin") || pathname.startsWith("/account")) {
    return <AdminContentSkeleton />;
  }

  return <PageFallbackSkeleton />;
}
